module.exports = __webpack_public_path__ + "static/media/aiff.998c1b2d.png";